module.exports = {
      id: "arrow-circle-right-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#arrow-circle-right",
      toString: function () {
        return this.url;
      }
    }